import React from 'react';
import './CustomTable3.scss';


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TablePagination from '@material-ui/core/TablePagination';
import {Link} from 'react-router-dom'
import moment from 'moment'
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { MenuItem, FormControl, Select } from '@material-ui/core';

import Checkbox from '@material-ui/core/Checkbox'
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';

import Icon from '@mdi/react'
import { mdiDotsVertical, mdiArrowDown,mdiCloudUpload, mdiCloudDownload, mdiCart,mdiPencil } from '@mdi/js'

import CustomIconButton from '../../basic/customIconButton'

import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';
import uuid from 'uuid4'

import {isMobileSafari} from 'react-device-detect';

@inject('internal')
@inject('translate')
@observer
export default class CustomTable3 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // order: 'asc',
            // orderBy: 'last_name',
            // order: toJS(this.props.internal.dataForTable.meta.order[0].dir),
            order: toJS(this.props.internal.dataForTable.meta.order).length ? toJS(this.props.internal.dataForTable.meta.order[0].dir) : "",
            // orderBy: toJS(this.props.internal.dataForTable.meta.order[0].by),
            orderBy: toJS(this.props.internal.dataForTable.meta.order).length ? toJS(this.props.internal.dataForTable.meta.order[0].by) : "",
            //page: Number(toJS(this.props.internal.dataForTable.meta.current_page)) -1,
            //rowsPerPage: Number(toJS(this.props.internal.dataForTable.meta.per_page)),
            //total: Number(toJS(this.props.internal.dataForTable.meta.total)),
            checkedRows: [],
            color: null,
            selectAll: false,
            isIOS: false,
        }
    }

    componentDidMount() {
        if(isMobileSafari) {
            this.setState({isIOS: true})
        }
     }
    
    createSortHandler = (orderBy) => {
        let currentOrder = this.state.order;
        this.setState({orderBy: orderBy});
        if(currentOrder === 'asc') {
            this.setState({order: "desc"}, () => {
                this.props.handleSort(this.state.order, this.state.orderBy);
            })
        }
        else {
            this.setState({order: "asc"}, () => {
                this.props.handleSort(this.state.order, this.state.orderBy);
            })
        }
    }

    handleChangePage = (event, page) => {
        this.props.handleChangePage(page);
        //this.setState({ page: page });
    };
    
    handleChangeRowsPerPage = event => {
        let numberOfRows;
        if(event.target.value === this.props.translate.i18n.GLOBAL.TABLE.ALL) {
            numberOfRows = Number(toJS(this.props.internal.dataForTable.meta.total))
        }
        else {
            numberOfRows = event.target.value
        }
        //this.setState({ rowsPerPage: event.target.value });
        this.props.handleChangeRowsPerPage(numberOfRows);
        this.props.internal.administrators = [];
    };

    createWrap = (data, type) => {
        if(type === "email"){
            let mailto = `mailto:${data[type]}`
            return <a href={mailto}>{data[type]}</a>
        }
        else if(type === "phone") {
            let tel = `tel:${data[type]}`
            return <a href={tel}>{data[type]}</a>
        }
        else if(type === "clients_count") {
            
            return <Link to={`/administrators/${data.id}/edit/tab=2`}>{data[type]}</Link>
            // if(data.id === loggedUserId) {
            //     return <Link to={`/administrators/${data.id}/edit/tab=2`}>{data[type]}</Link>
            // }else
            // {
            //     return <Link to={`/administrators/${data.id}/edit/tab=1`}>{data[type]}</Link>
            // }
            
        }
        else if(type === "role_name") {
            let tmpData = data[type].toUpperCase()
            return this.props.translate.i18n.MODULES.CLIENTS.ROLES[tmpData]
        }
        else if(type === "role_id") {
            return this.props.translate.i18n.GLOBAL.ROLES[data[type]]
        }
        else if(type === "document_type") {
            let tmpData = data[type].toUpperCase()
            return this.props.translate.i18n.GLOBAL.DOC_TYPES[tmpData]
        }
        else if(type === "warehouse_status_name") {
            
            
            if(data['warehouse_info'] == 0) {
                
                let status = data[type].toUpperCase()
                return this.props.translate.i18n.MODULES.PRODUCTS[status]
            }
            else if(data['warehouse_info'] > 0 && data['warehouse_info'] <=5) {
                return this.props.translate.i18n.MODULES.PRODUCTS.AVAILABLE_LESS
            }
            else{
                return this.props.translate.i18n.MODULES.PRODUCTS.AVAILABLE
            }
            
        }
        else if(type === "created_at" || type === "updated_at" || type === "import") {
            // let date = dateformat(data[type], "dd.mm.yyyy HH:MM")
            // let date = new Date(data[type], "dd.mm.yyyy HH:MM")
            let date = moment(data[type]).format("DD.MM.YYYY HH:mm")
            return date;

        }
        else if(type === 'published_from' || type === "published_until") {
            let date = moment(data[type]).format("DD.MM.YYYY")
            return date;
        }
       
        else if(type === "retail_price" || type === "total" || type === "client_price" || type === "free_from" || type === "price" || type === "client_price_with_vat" || type === "retail_price_with_vat" || type === 'price_from') {
            const formatter = new Intl.NumberFormat('sk-SK', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            })

            if(this.props.showAllClientPrices && (toJS(this.props.internal.user.data.role.id) < 3) ) {

                return (
                    <Tooltip title={
                        <ul className={'rabat-level-prices'}>
                            <li>{this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL} 1: {toJS(data.rabat_1) !== null ? <span>{formatter.format(toJS(data.rabat_1))}</span> : ""}</li>
                            <li>{this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL} 2: {toJS(data.rabat_2) !== null ? <span>{formatter.format(toJS(data.rabat_2))}</span> : ""}</li>
                            <li>{this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL} 3: {toJS(data.rabat_3) !== null ? <span>{formatter.format(toJS(data.rabat_3))}</span> : ""}</li>
                            <li>{this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL} 4: {toJS(data.rabat_4) !== null ? <span>{formatter.format(toJS(data.rabat_4))}</span> : ""}</li>
                            <li>{this.props.translate.i18n.MODULES.CLIENTS.RABAT_LEVEL} 5: {toJS(data.rabat_5) !== null ? <span>{formatter.format(toJS(data.rabat_5))}</span> : ""}</li>
                        </ul>
                    }>
                        <div className={'price-list-products'}>{formatter.format(data[type])}</div>
                    </Tooltip>
                )
            }
            else {
                return <div style={{textAlign:"right"}}>{formatter.format(data[type])}</div>
            }
            
        }
        else if(type === "production") {
            if(data[type] === true){
                return( <div style={{textAlign: "center"}} className={'production-icon'} onClick={() => this.props.clickOnProductionStatus(data.id, false)}><Icon path={mdiCloudUpload} size={1} className={`production-${data[type]}`} /> </div>)
            }
            else{
                return (<div style={{textAlign: "center"}} className={'production-icon'} onClick={() => this.props.clickOnProductionStatus(data.id, true)}><Icon path={mdiCloudDownload} size={1} className={`production-${data[type]}`} /></div>)
            }
        }
        else if(type === "tags") {
            return <div className={'tags'}>
                {data[type].map((tag, index) => {
                    return <span key={tag.id} style={{backgroundColor: tag.color}} className={'tag'}>{tag.name}</span>
                })}
            </div>
        }
        else if(type === "status") {
            let tmp = data[type].toUpperCase();
            return this.props.translate.i18n.MODULES.CLIENTS.OREDER_STATE[tmp]
        }
        else if(type === "color") {
            
            return <span className={'color-tag'} style={{backgroundColor:data[type]}}></span>
        }
        else if(type === "available") {
            let available = data[type] ? "#79C552" : "#ee5c4e"
            return <span className={'available'} style={{backgroundColor:available}}></span>
        }
        //link ktory bude smerovat na product a filter podla tagu
        else if(type === 'products_count') {
            // return data[type]
            if(this.props.module === '/fixed-sets') {
                return data[type]
            }
            else {
                return <a href={`/products?tags=${data.id}`}>{data[type]}</a>
            }
        }
        //tuto je pre zmenu pozici polozky v menu
        else if(type === 'id') {
            return (
                <IconButton
                    style={{display: "block", margin: "0 auto"}}
                    aria-label="Menu"
                    className={'burger-menu-btn'}
                    onClick={e => this.props.openDialogSiblings({e, data})}
                >
                    <MenuIcon />
                </IconButton>
            )
        }
        // select pre nastavenie typu pre menu item
        else if(type === "frontend_menu_type_id") {
            const { lists } = toJS(this.props.internal.dataForTable)
            return (
                
                <div style={{textAlign: "left"}}>{this.props.translate.i18n.MODULES.MENU.MENU_TYPES[toJS(data.frontend_menu_type.name).toUpperCase()]}</div>

                // <FormControl className="select-type w-100">
                
                //     <Select
                //         disableUnderline
                //         classes={{
                //             root: "select-menu-type-root"
                //         }}
                //         // value={this.state.typeMenu}
                //         value={toJS(data.frontend_menu_type_id)}
                //         onChange={e => this.props.updateTypeMenuItem(e, data)}
                //         placeholder={'testik'}
                //         inputProps={{
                //             name: "menu_type",
                //             id: "menu-type",
                //         }}
                //         displayEmpty
                //         IconComponent={() => null}
                //         style={{textAlign: "left"}}
                //     >
                //         {lists.frontend_menu_types.map((frontend_menu_type, index) => {
                //             return (
                //                 <MenuItem key={frontend_menu_type.id} value={frontend_menu_type.id}>{this.props.translate.i18n.MODULES.MENU.MENU_TYPES[(frontend_menu_type.name).toUpperCase()]}</MenuItem>
                //             )
                //         })}
                //     </Select>
                // </FormControl>
            )
        }
        else if(type === "discount") {
            return `${data[type]}%`
        }
        else if(type === "extension") {
        }
        else if(type === "action_items") {
            return <div onClick={() => this.props.changeItems(data.id)}><Icon path={mdiPencil} size={1} className={'btn-action-plus'} /></div>
        }
        else if(type === "role") {
            return this.props.translate.i18n.GLOBAL.ROLES[data.role.id]
        }
        else if(type === "buy_item") {
            let loader = toJS(this.props.internal.loader);
            if(loader.loading && toJS(data.id) === loader.id) {
                return <div className={'buy-item'}><CircularProgress className = {'table-circular-progress'}/> </div>
            }
            else {
                return  <div className={'buy-item'} onClick={() => this.props.addToShoppingCart(data.id)}>
                            <Icon path = {mdiCart} size = {1 } style={{fill:"#FF7800", marginRight: "2px"}}/>
                        </div>
            }
        }
        else if(type === "rabat_level") {
            if(data[type] === null) {
                return "0%"
            }
            else if(data[type] === 1) {
                return "30%"
            }
            else if(data[type] === 2) {
                return "20%"
            }
            else if(data[type] === 3) {
                return "23%"
            }
            else if(data[type] === 4) {
                return "25%"
            }
            else if(data[type] === 5) {
                return "27%"
            }
        }
        else if(type === 'order_count' && this.props.module === '/customers') {
            // return data[type]
            return <Link to={`/customers-orders?customer_id=${toJS(data.id)}`}>{data[type]}</Link>
        }
        else if(type === 'billing_username') {
            return (<div className={'customerUsername'} onClick={() => this.props.handleShowBillingDeliveryData(toJS(data))}>{data.billing_first_name} {data.billing_last_name}</div>)
        }
        else if(type === 'customer_order_status') {
            return (<div className={'customerOrderStatus'} onClick={() => this.props.handleCustomerOrderStatus(toJS(data))}>{data.customer_order_status.name}</div>)
        }
        else if(type === 'total_with_vat') {
            const formatter = new Intl.NumberFormat('sk-SK', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2
            })
            return (
                <Tooltip title={
                    <ul className={'pricesForOrder'}>
                        <li>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].PRODUCTS_TOTAL_WITH_VAT}: &nbsp;<span>{formatter.format(toJS(data.products_total_with_vat))}</span></li>
                        <li>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].DELIVERY_TYPE_PRICE_WITH_VAT}: &nbsp;<span>{formatter.format(toJS(data.delivery_type_price_with_vat))}</span></li>
                        <li>{this.props.translate.i18n.MODULES['CUSTOMERS-ORDERS'].PAYMENT_TYPE_PRICE_WITH_VAT}: &nbsp;<span>{formatter.format(toJS(data.payment_type_price_with_vat))}</span></li>
                    </ul>
                }>
                    <div className={'fullPrice'}>{formatter.format(data[type])}</div>
                </Tooltip>
            )
        }
        else if(type === 'delivery_type') {
            return data['delivery_type'].name
        }
        else if(type === 'payment_type') {
            return data['payment_type'].name
        }
        else if(type === 'paid_at') {
            return (<div className={'paymentStatus'} onClick={() => this.props.handlePaymentStatus(toJS(data))}>{data[type] === null ? this.props.translate.i18n.GLOBAL.BUTTONS.NO : this.props.translate.i18n.GLOBAL.BUTTONS.YES}</div>)
        }
        else if(type === 'is_for_shops') {
            if(data[type] === true) {
                return this.props.translate.i18n.MODULES.STATIC_PAGES.ESHOPS
            }
            else {
                return this.props.translate.i18n.MODULES.STATIC_PAGES.B2B
            }
            // return data[type].toString()
        }
        else {
            return data[type]
        }
    }

    handleCheckRow = (rowId) => {
        let checkedRow = this.state.checkedRows;
        let newChecked = []
        let rowIsNotChecked = false;
        checkedRow.filter(function(data) {
            if(data !== rowId) {
                newChecked.push(data)
            }
            else {
                rowIsNotChecked = true
            }
            return null
        })

        if(!rowIsNotChecked) {
            newChecked.push(rowId)
        }
        
        this.setState({checkedRows: newChecked, selectAll: false }, () => {
            this.props.internal.setCheckedRows(this.state.checkedRows)
        })
    }

    handleSelectAll = event => {
        if (event.target.checked) {
            this.setState({ checkedRows: this.props.internal.dataForTable.data.map(n => n.id), selectAll: true }, () => {
                this.props.internal.setCheckedRows(this.state.checkedRows)
            
            })
        }
        else {
            this.setState({ checkedRows: [], selectAll: false  }, () => {
                this.props.internal.setCheckedRows(this.state.checkedRows);
            })
        }
        
    }


    render() {

        let MODULE = this.props.module.substring(1).toUpperCase()
        return (
            <div className={'custom-table'}>
            <Paper className={`table-box ${this.state.isIOS ? 'ios' : ''}`} >
                {/* <div className={`${Number(toJS(this.props.internal.checkedRows).length) > 0 ? 'mobile-action': '' }`}></div> */}
                <Table >
                    <TableHead>
                    <TableRow>
                        {this.props.firstCellCheckbox
                            ?
                            <TableCell className={'firstCellCheckbox'} onClick={this.handleSelectAll}>
                                <Checkbox
                                    value={''}
                                    checked={this.state.selectAll}
                                    className={'custom-checkbox'}
                                />
                            </TableCell>
                            :
                            null
                        }
                            
                            <TableCell></TableCell>
                        {this.props.header.map((data, index) => {
                            let DATA = data.title.toUpperCase();
                            return (
                                <TableCell
                                    key={uuid()}
                                    onClick={this.props.disableSort || data.disabled ? null : () =>this.createSortHandler(data.sortBy?data.sortBy: data.title)}
                                    numeric={data.numeric}
                                    style={{textAlign:data.textAlign, minWidth: data.min_width ? data.min_width : 0}}
                                >
                                    
                                    {this.props.translate.i18n.MODULES[MODULE][DATA]}
                                        {this.props.disableSort
                                            ?
                                            null
                                            :
                                            this.state.orderBy === data.title || this.state.orderBy === data.sortBy ?
                                                <Icon path={mdiArrowDown} size={1} className={this.state.order === 'desc' ? ' desc' : 'asc'} />
                                                : null
                                        }
                                </TableCell>
                            );
                        })}
                        
                        
                    </TableRow>
                    </TableHead>
                    <TableBody>
                        {(this.props.internal.dataForTable.data).length === 0 ?
                        <TableRow ><TableCell colSpan={this.props.firstCellCheckbox ? this.props.body.length + 2 : this.props.body.length + 1} style={{textAlign:'center'}}>{this.props.translate.i18n.GLOBAL.ALERTS.NO_FOUND_DATA_FOR_TABE}</TableCell></TableRow>
                        :
                        
                        //     stableSort(this.props.internal.dataForTable.data, getSorting(this.state.order,  this.state.orderBy))
                        //    .map(data => {
                            this.state.checkedRows && this.props.internal.dataForTable.data.map(data => {
                                return (
                                    <TableRow key={data.id}>
                                        {this.props.firstCellCheckbox
                                            ?
                                            <TableCell className={'firstCellCheckbox'} onClick={() => this.handleCheckRow(data.id)}>
                                                <Checkbox
                                                    checked={this.state.checkedRows.includes(data.id)}
                                                    //onChange={this.handleChange('checkedA')}
                                                    value={data.name}
                                                    className={'custom-checkbox'}
                                                />
                                            </TableCell>
                                            :
                                            null
                                        }
                                        
                                        <TableCell className={'cell-with-icon'}>
                                        {this.props.dropDownMenuItems.length > 0 ?
                                            <CustomIconButton
                                                id={data.id}
                                                label="More"
                                                dropdownMenu
                                                items={this.props.dropDownMenuItems}
                                                module={this.props.module}
                                                data={data}
                                            >
                                                <Icon path={mdiDotsVertical} size={1} />
                                            </CustomIconButton>
                                            :
                                            null
                                        }
                                        </TableCell>
                                        
                                        {this.props.body.map((cellName, index) => {
                                            return (
                                                <TableCell
                                                    key={uuid()}
                                                    numeric={cellName === 'role_id' ? false : Number.isInteger(data[cellName])}
                                                    style={{textAlign: `${cellName === 'rabat_level'?  'right ' : ''}`}}
                                                    >
                                                        {//data[cellName]
                                                            this.createWrap(data, cellName)
                                                        }
                                                    </TableCell>
                                            );
                                        })}
                                    </TableRow>
                                );
                            })
                        }
                    
                    </TableBody>
                </Table>
                </Paper>
                {this.props.disablePagination ? null :
                    <TablePagination
                        classes={{caption:"caption", selectIcon: "selectIcon", select: "selectPerPage"}}
                        component="div"
                        rowsPerPageOptions={[5,10,15,25,50, this.props.translate.i18n.GLOBAL.TABLE.ALL]}
                        className={'pagination'}
                        count={Number(toJS(this.props.internal.dataForTable.meta.total))}
                        rowsPerPage={Number(toJS(this.props.internal.dataForTable.meta.per_page))}
                        page={Number(toJS(this.props.internal.dataForTable.meta.current_page)) -1}
                        backIconButtonProps={{
                            'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                            'aria-label': 'Next Page',
                        }}
                        labelDisplayedRows={({from, to, count}) => `${from}-${to} z ${count}`}
                        onChangePage={this.handleChangePage}
                        onChangeRowsPerPage={this.handleChangeRowsPerPage}
                        labelRowsPerPage={this.props.translate.i18n.GLOBAL.TABLE.LABEL_ROWS_PER_PAGE}
                        />
                    }
                </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/complex/CustomTable3/CustomTable3.jsx